import {BreadCrumb} from "./bread-crumb";

export class SessionStorageStackService {

  constructor(private stackKey: string) {
    let initial: BreadCrumb[] = [];
    this.saveBreadCrumbs(initial);
  }

  pushNew(element: BreadCrumb) {
    const breadCrumbs = this.getBreadCrumbs();
    breadCrumbs.push(element);
    this.saveBreadCrumbs(breadCrumbs);
  }

  clearAllElements() {
    this.saveBreadCrumbs([]);
  }

  getBreadCrumbs(): BreadCrumb[] {
    let localStorageValue = localStorage.getItem(this.stackKey);
    if (localStorageValue === undefined || localStorageValue.length === 0) {
      localStorageValue = "[]";
    }
    return JSON.parse(localStorageValue);
  }

  private saveBreadCrumbs(breadCrumbs: BreadCrumb []) {
    localStorage.setItem(this.stackKey, JSON.stringify(breadCrumbs));
  }

  public clearLocalStorage(): void {
    localStorage.removeItem(this.stackKey);
  }
}
